import { Component } from '@angular/core';
import { PermissionStatusCode } from '@app/municipality-management/models/externe-apps';
import { MunicipalityManagementConfigurationStore } from '@app/municipality-management/services/municipality-management-configuration.store';
import { MunicipalityManagementQueueStateService, PermissionType } from '@app/municipality-management/services/municipality-management-queue-state.service';
import { PermissionCode } from '@app/shared/enums';
import { FeaturePermission, Permission } from '@app/shared/services/api/permission.service';
import { AuthService } from '@app/shared/services/auth.service';
import { Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-premium-features-activation-tab',
  templateUrl: './premium-features-activation-tab.component.html',
  styleUrls: ['./premium-features-activation-tab.component.scss'],
})
export class PremiumFeaturesActivationTabComponent {
  premiumFeatures$: Observable<Permission[]>;
  isMunicipalityActive$ = this._configStore.isMunicipalityActive$;

  constructor(
    private _configStore: MunicipalityManagementConfigurationStore,
    public authService: AuthService,
    private _queueStateService: MunicipalityManagementQueueStateService
  ) {
    this.premiumFeatures$ = this._configStore.municipalityPremiumFeaturesConfig$.pipe(distinctUntilChanged());
  }

  /**
   * isRestricted = if value is true: checkbox has no value
   * @param isChecked
   * @param featureId
   */
  toggleFeature(isChecked: boolean, featureId: string) {
    const updatedFeatures = this._configStore.municipalityFeaturesConfig.map((feature) => {
      if (feature.guid === featureId) {
        const permissionStatusCode = isChecked ? PermissionStatusCode.ACTIVATEDBYMUNICIPALITY : PermissionStatusCode.DEACTIVATEDBYMUNICIPALITY;
        this._queueStateService.addStatustoQueue(permissionStatusCode, feature as FeaturePermission, PermissionType.PREMIUM);
        if (!isChecked) {
          return { ...feature, isRestricted: true };
        }
        return { ...feature, isRestricted: !isChecked, isTeaser: !isChecked };
      }
      return { ...feature };
    });
    this._configStore.setFeaturesConfig(updatedFeatures);
  }

  toggleTeaser(isChecked: boolean, featureId: string) {
    const updatedFeatures = this._configStore.municipalityFeaturesConfig.map((feature) => {
      if (feature.guid === featureId) {
        const permissionStatusCode = isChecked ? PermissionStatusCode.TEASERBYMUNICIPALITY : PermissionStatusCode.DEACTIVATEDBYMUNICIPALITY;
        this._queueStateService.addStatustoQueue(permissionStatusCode, feature as FeaturePermission, PermissionType.PREMIUM);
        if (!isChecked) {
          return { ...feature, isTeaser: false };
        }
        return { ...feature, isTeaser: isChecked, isRestricted: isChecked };
      }
      return { ...feature };
    });
    this._configStore.setFeaturesConfig(updatedFeatures);
  }

  updateLink(event: Event, feature: Permission) {
    const value = (event.target as any).value;
    switch (feature.code) {
      case PermissionCode.LOCAL_ELECTRICITY_MARKET_LINK:
        this._configStore.setMunicipalityConfig({ localElectricityMarketUrl: value });
        break;
      case PermissionCode.CO2_BALANCE_SHEET_LINK:
        this._configStore.setMunicipalityConfig({ climateNaviUrl: value });
        break;
      case PermissionCode.ENERGY_MONITOR:
        this._configStore.setMunicipalityConfig({ energyMonitorUrl: value });
        break;
      case PermissionCode.ROOM_MONITORING:
        this._configStore.setMunicipalityConfig({ roomMonitoringUrl: value });
        break;
      default:
        break;
    }
  }
}
